import React, { Component } from "react";
import { Grid, Row, Col, Thumbnail, Image } from "react-bootstrap";
import ReactCardFlip from "react-card-flip";
import "./Services.css";
import config from "../config.services";

export default class Services extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFlipped: [],
      id: "",
      sel: true,
      id2: "",
    };
  }
  // handleClickFront = (evt, index) => {
  //   const {isFlipped} = this.state;
  //   isFlipped[index] = !isFlipped[index];
  //   this.setState({...isFlipped});
  // }
  openTabSection = (evt, tabNmae) => {
    console.log("map " + tabNmae);
    console.log("index " + this.state.id2);
    console.log("map state " + this.state.id);
    this.setState({ id: tabNmae, sel: false });
    let i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabs_item");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].classList.remove("fadeInUp");
      tabcontent[i].style.display = "none";
    }

    tablinks = document.getElementsByTagName("li");
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace("current", "");
    }

    document.getElementById(tabNmae).style.display = "block";
    document.getElementById(tabNmae).className += " fadeInUp animated";
    evt.currentTarget.className += " current";
  };
  rendersDesktop() {
    return (
      <Grid>
        <Row>
          <Col md={6} className="text">
            <h3 className="title">{config.title}</h3>
          </Col>
        </Row>
        <Row>
          {config.services.map((item, index) => {
            return (
              <Col
                lg={6}
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  this.openTabSection(e, item.id);
                }}
                style={{ cursor: "pointer" }}
              >
                <div class="group-div">
                  <div class="rectangle-div1" arrw>
                    <Image src="/images/arrow.png" alt="" title="" responsive />
                  </div>
                  {item.id === this.state.id || item.sel === this.state.sel ? (
                    <div class="rectangle-div2">
                      {" "}
                      <Image
                        src="/images/line.png"
                        alt=""
                        title=""
                        responsive
                      />
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <div class="rectangle-div3">
                    <img
                      src={item.icon}
                      alt=""
                      title=""
                      responsive
                      class="img-icon"
                    />
                  </div>
                  <p class="obras-p">{item.title}</p>
                </div>
              </Col>
            );
          })}
        </Row>
        <Row className="tab  tab-services align-items-center justify-content-center">
          <div className="container">
            {config.services.map((item, index) => {
              return (
                <div key={index} id={item.id} className="tabs_item">
                  <div className="row align-items-center pd">
                    <div className="col-lg-12 col-md-12">
                      <h2>{item.title}</h2>
                      <p>{item.description}</p>
                    </div>{" "}
                  </div>
                </div>
              );
            })}
          </div>
        </Row>
      </Grid>
    );
  }
  renderMobile() {
    return (
      <Grid>
        <Row>
          <Col md={6} className="text">
            <h3 className="title">{config.title}</h3>
          </Col>
        </Row>
        <Row>
          {config.services.map((item, index) => {
            return (
              <Col
                lg={4}
                key={index}
                onClick={(e) => {
                  e.preventDefault();
                  this.openTabSection(e, item.id);
                }}
                style={{ cursor: "pointer" }}
              >
                <div class="group-div">
                  <div class="rectangle-div1" arrw>
                    <Image src="/images/arrow.png" alt="" title="" responsive />
                  </div>
                  {item.id === this.state.id || item.sel === this.state.sel ? (
                    <div class="rectangle-div2">
                      {" "}
                      <Image
                        src="/images/line.png"
                        alt=""
                        title=""
                        responsive
                      />
                    </div>
                  ) : (
                    <div></div>
                  )}
                  <div class="rectangle-div3">
                    <img
                      src={item.icon}
                      alt=""
                      title=""
                      responsive
                      class="img-icon"
                    />
                  </div>
                  <p class="obras-p">{item.title}</p>
                </div>
                {item.id === this.state.id || item.sel === this.state.sel ? (
                  <Row className="tab  tab-services align-items-center justify-content-center">
                    <div
                      className="container"
                      onClick={() => this.setState({ id2: this.state.id })}
                    >
                      <div key={index} id={item.id} className="tabs_item2">
                        <div className="row align-items-center pd">
                          <div className="col-lg-12 col-md-12">
                            <h2>{item.title}</h2>
                            <p>{item.description}</p>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </Row>
                ) : (
                  <div></div>
                )}
              </Col>
            );
          })}
        </Row>
      </Grid>
    );
  }

  render() {
    return (
      <div className="Services">
        <div class="bar"></div>
        <div className="gridDesktop">{this.rendersDesktop()}</div>
        <div className="gridMobile">{this.renderMobile()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Services.js